<div class="card p-2">
    <div class="col">
        <p-button pRipple type="button" icon="pi pi-search"
                  label="{{ 'table.buttons.advanceSearch' | translate }}"
                  class="p-button-raised p-button-danger float-end" severity="danger"
                  (click)="showAdvanceSearch()"></p-button>
        <p-button pRipple type="button" icon="pi pi-user-plus"
                  label="{{ 'table.buttons.newAssignment' | translate }}"
                  class="p-button-raised p-button-danger float-end me-2" severity="danger"
                  (click)="showModalDialog()"></p-button>
    </div>


    <p-table #dt1 [value]="assigmentModels"
             [rows]="pageSize"
             [totalRecords]="totalRecords"
             [paginator]="true"
             [lazy]="true"
             (onLazyLoad)="loadAssigmentData($event)"
             [loading]="loading"
             stripedRows
             [rowsPerPageOptions]="[10, 25, 50, 100]">
        <ng-template pTemplate="header">
            <tr class="table-header-assigements">
                <th>{{ 'table.header.number' | translate }}</th>
                <th pSortableColumn="customerName">
                    {{ 'table.header.customer' | translate }}
                    <p-sortIcon field="customerName"></p-sortIcon>
                </th>
                <th pSortableColumn="areaDescription">
                    {{ 'table.header.team' | translate }}
                    <p-sortIcon field="areaDescription"></p-sortIcon>
                </th>
                <th pSortableColumn="responsibleName">
                    {{ 'table.header.responsible' | translate }}
                    <p-sortIcon field="responsibleName"></p-sortIcon>
                </th>
                <th pSortableColumn="status">
                    {{ 'table.header.active' | translate }}
                    <p-sortIcon field="status"></p-sortIcon>
                </th>
                <th>{{ 'table.header.actions' | translate }}</th>
            </tr>
        </ng-template>
        <ng-template pTemplate="body" let-assignment let-i="rowIndex">
            <tr>
                <td>
                    {{ i + 1 }}
                </td>
                <td>
                    {{ assignment.customerName }}
                </td>
                <td>
                    {{ assignment.areaDescription }}
                </td>
                <td>
                    {{ assignment.responsibleName }}
                </td>
                <td class="text-center">
                    <i class="pi"
                       [ngClass]="{'true-icon pi-check-circle': assignment.status, 'false-icon pi-times-circle': !assignment.status}"></i>
                </td>
                <td>
                    <button pButton pRipple type="button" (click)="op.toggle($event)"
                            class="p-button-text p-button-plain">...
                    </button>
                    <p-popover #op [style]="{width: '250px'}">
                        <table [cellPadding]="0" [cellSpacing]="0" [width]="'100%'">
                            <tr>
                                <td>
                                    <button pButton pRipple type="button"
                                            icon="pi pi-user-edit"
                                            label="{{ 'table.buttons.editAssignment' | translate }}"
                                            (click)="showDetailAssignment(assignment); op.toggle($event)"
                                            class="p-button-text p-button-plain w-100"></button>
                                </td>
                            <tr>
                                <td>
                                    <button pButton pRipple type="button"
                                            icon="pi pi-trash"
                                            label="{{ 'table.buttons.deleteAssignment' | translate }}"
                                            (click)="deleteAssignment(assignment); op.toggle($event)"
                                            class="p-button-text p-button-plain w-100"></button>
                                </td>
                            </tr>
                        </table>
                    </p-popover>
            </tr>
        </ng-template>
        <ng-template pTemplate="emptymessage">
            <tr>
                <td colspan="7">{{ 'table.emptyMessage' | translate }}</td>
            </tr>
        </ng-template>
    </p-table>
</div>
<p-confirmDialog header="{{ 'confirmDialog.header' | translate }}"
                 acceptButtonStyleClass="p-button-outlined p-button-danger"
                 rejectButtonStyleClass="p-button-raised p-button-danger"
                 icon="pi pi-exclamation-triangle"></p-confirmDialog>
<p-toast></p-toast>


<p-drawer [(visible)]="activeAdvanceSearch" position="right"
          [closeOnEscape]="true"
          [baseZIndex]="10000"
          (onHide)="clearForm()">
    <form [formGroup]="searchFormGroup">
        <div class="text-center">
            <h3>{{ 'sidebar.advanceSearch.title' | translate }}</h3>
        </div>
        <div class="mt-2">
            <label for="teamTxt">{{ 'sidebar.advanceSearch.team' | translate }}</label>
            <div class="p-inputgroup">
                <input type="text" id="teamTxt" pInputText readonly
                       (click)="searchTeam()"
                       class="w80"
                       formControlName="areaDescription">
                <button type="button" pButton pRipple icon="pi pi-search"
                        class="p-button-danger" (click)="searchTeam()"></button>
            </div>
        </div>
        <div class="mt-2">
            <label for="responsibleTxt">{{ 'sidebar.advanceSearch.responsible' | translate }}</label>
            <div class="p-inputgroup">
                <input type="text" id="responsibleTxt" pInputText readonly
                       (click)="searchResponsible()"
                       class="w80"
                       formControlName="responsibleName">
                <button type="button" pButton pRipple icon="pi pi-search"
                        class="p-button-danger" (click)="searchResponsible()"></button>
            </div>
        </div>
        <div class="mt-2">
            <label for="customerTxt">{{ 'sidebar.advanceSearch.customer' | translate }}</label>
            <div class="p-inputgroup">
                <input type="text" id="customerTxt" pInputText readonly
                       (click)="searchCustomer()"
                       class="w80"
                       formControlName="customerName">
                <button type="button" pButton pRipple icon="pi pi-search"
                        class="p-button-danger" (click)="searchCustomer()"></button>
            </div>
        </div>
        <div class="mt-3">
            <button pButton pRipple type="button" icon="pi pi-search"
                    (click)="searchAssignments()"
                    severity="danger"
                    label="{{ 'sidebar.advanceSearch.search' | translate }}"
                    class="p-button-raised p-button-danger w-100"></button>
        </div>
    </form>
</p-drawer>